import {Form, InputNumber, Select, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import Wysiwyg from "../../../../../shared/input/Wysiwyg";
import LocaleText from "../../../../settings/dictionary/LocaleText";

export interface IFieldWYSIWYGOptions {
    wysiwygPackage?: 'basic' | 'medium' | 'full',
    wysiwygInlineFile?: boolean,
    wysiwygMinHeight?: number
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldWysiwygOptionEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('wysiwygPackage')} label={<LocaleText code={'configuration.widget.wysiwyg.mode'} fallback={'Zvolte wysiwyg balicek'}/>}
                           rules={[{required: true}]} initialValue={'basic'}>
                    <Select>
                        {Wysiwyg.MODE_OPTIONS.map(type => (
                            <Select.Option key={type.code} value={type.code}>{type.label}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name={buildFieldName('wysiwygInlineFile')} label={<LocaleText code={'configuration.widget.wysiwyg.file-insert'} fallback={'Vkládání souboru'}/>}
                           valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
                <Form.Item name={buildFieldName('wysiwygMinHeight')} label={<LocaleText code={'configuration.widget.wysiwyg.min-height'} fallback={'Minimální výška'}/>}>
                    <InputNumber min={0} max={2000}/>
                </Form.Item>
            </div>
        )
    }
}

export default FieldWysiwygOptionEditor